import React from 'react'
import StoryItem from '../item/StoryItem'
import StoryItemSetting from '../item/StoryItemSetting'
import CharacterSetting from '../item/CharacterSetting'
import GlobalStorage from '../storage/GlobalStorage'
import {Container,Row,Col, Button,ButtonGroup, Nav, NavItem, NavLink, TabContent, TabPane, Modal, ModalBody, ModalHeader, ModalFooter} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAlignCenter,faBook,faComments,faImage, faUserPlus, faCaretRight, faCaretLeft} from '@fortawesome/free-solid-svg-icons'

function array_move(arr, old_index, new_index) {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing
};

export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.state = {
      is_ready: false,
      openModal: false,
      activeCharacter:'',
      characterExpanded:true,
    }
    this.GS = new GlobalStorage();
    this.items = this.GS.getStoryEpisodeItems();
    this.characters = this.GS.getCharacters();
    this.toggleModal = this.toggleModal.bind(this);    
  }
  toggleModal(open) 
  {
    var open = open || false;    
    
    if (!open)
      this.setState(prevState => ({
        openModal: !prevState.openModal,      
      }));
    else
    this.setState(prevState => ({
      openModal: open
    }));
    
  }
  
  toggleCharacter(tab) {
    if (this.state.activeCharacter !== tab) {
      this.setState({
        activeCharacter: tab,
        openModal: true
      });
    }else{
      this.setState({
        activeCharacter: ''
      });
    }
  }

  componentDidMount() {
    this.setState({
      is_ready: true
    });    
    this.onChangeItem = this.onChangeItem.bind(this);
  }

  onChangeItem()
  {
    //console.log("StoryEpisode:onChangeItem");
    this.forceUpdate();
  }

  render()
  {
    return (
        <Container>
          <Row>
            <Col md="8">
          {
          this.state.is_ready ? (
              <div id="items" class="mt-5">
                {
                  this.items.map((item, i) => {
                    return (
                        <StoryItem {...this.props}                                           
                                        key={i}
                                        index={i}
                                        item={item}
                                        onSelect={(item) => {
                                          if (item.isSelected)
                                          {
                                            item.isSelected = !item.isSelected;
                                            this.forceUpdate();
                                          }
                                          else
                                          {
                                            for (var k = 0; k < this.items.length; k++)
                                            {
                                              this.items[k].isSelected = false;
                                            }
                                            item.isSelected = true;
                                            this.forceUpdate();
                                          }
                                        }}
                                        onRemove={(item) => {
                                          if (window.confirm("確認刪除?"))
                                          {
                                            this.items.splice(i, 1);
                                            this.forceUpdate();
                                          }
                                        }}
                                        onShiftUp={(item) => {
                                          var shift = Number(window.prompt("移上多少格?","1"));
                                          var from = i;
                                          var to = i - shift;
                                          if (to < 0) {
                                            to = 0;
                                          }
                                          array_move(this.items, from, to);
                                          this.forceUpdate();
                                        }}
                                        onShiftDown={(item) => {
                                          var shift = Number(window.prompt("移下多少格?","1"));
                                          var from = i;
                                          var to = i + shift;
                                          if (to >= this.items.length) {
                                            to = this.items.length - 1;
                                          }
                                          array_move(this.items, from, to);
                                          this.forceUpdate();
                                        }}
                                        onShiftOrder={(item) => {
                                        var to = Number(window.prompt("移至哪一格?","1"));
                                        var from = i;
                                        if (to>=this.items.length-1){
                                          to = this.items.length-1;
                                        }
                                        //console.log(to);
                                        //console.log(from);
                                        if (to!=from && to!=0){
                                          array_move(this.items, from, to);
                                        }
                                        this.forceUpdate();
                                      }}
                                        onShiftAlign={(item) => {                                             
                                        if (item.type=='Narrative' || item.type=='Text'){
                                          switch (item._attributes.position){                                              
                                            case 'left':
                                                item._attributes.position = 'center';
                                                item._attributes.style = 'narrative';
                                                item.type='Narrative';
                                            break;
                                            case 'center':
                                                item._attributes.position = 'right';
                                                item._attributes.style = 'msg';
                                                item.type='Text';
                                            break;
                                            case 'right':
                                                item._attributes.position = 'left';
                                                item._attributes.style = 'msg';
                                                item.type='Text';
                                            break;                                              
                                          }
                                        }

                                        if (item.type=='Media'){
                                          switch (item._attributes.position){                                              
                                            case 'left':
                                                item._attributes.position = 'right';                                                
                                            break;                                            
                                            case 'right':
                                                item._attributes.position = 'left';                                                                                                
                                            break;                                              
                                          }
                                        }

                                        
                                        this.forceUpdate();
                                      }}
                                      onChangeItem={() => {
                                        this.onChangeItem();
                                      }}
                        />
                    )
                  })
                }
                <div className="text-center">
                  <ButtonGroup className="mr-auto">
                    <div class="input-group-prepend">
                      <div class="input-group-text" style={{color: "#ffffff",backgroundColor:"#6c757d",border: "1px solid #6c757d"}}>新增元素</div>
                    </div>        
                    <Button onClick={()=>{this.GS.addStoryEpisodeItem("Scene");this.forceUpdate();}}>
                      <FontAwesomeIcon icon={faBook} size="lg" title="新增分頁"/>
                    </Button>
                    <Button onClick={()=>{this.GS.addStoryEpisodeItem("Narrative");this.forceUpdate();}}>
                      <FontAwesomeIcon icon={faAlignCenter} size="lg" title="新增旁白"/>
                    </Button>
                    <Button onClick={()=>{this.GS.addStoryEpisodeItem("Text");this.forceUpdate();}}>
                      <FontAwesomeIcon icon={faComments} size="lg" title="新增對話"/>
                    </Button>
                    <Button onClick={()=>{this.GS.addStoryEpisodeItem("Media");this.forceUpdate();}}>
                      <FontAwesomeIcon icon={faImage} size="lg" title="新增媒體"/>
                    </Button>
                  </ButtonGroup>
                </div>          
                
                <div style={{height:"54px"}}></div>  
              </div>
              
              ) : null
            }
              </Col>
              <Col md="4" className="fixed-top" style={{top:`54px`,right:`0`,left:`auto`}} >
              {
            this.state.is_ready ? (
                <div>
                  {
                    this.items.map((item, i) => {
                      return (
                          <StoryItemSetting {...this.props}                                           
                                          key={i}
                                          index={i}
                                          item={item}                                          
                                          onChangeItem={() => {
                                            this.onChangeItem();
                                          }}
                          />
                      )
                    })
                  }                  
                </div>
                ) : null
              }                                                  
              </Col>
              <Col md="12" className="fixed-bottom" style={{bottom:(global.DEBUG)?`54px`:`0`,left:(this.state.characterExpanded)?`0`:`-94%`,right:`auto`}} >
                <Nav tabs>                  
                    {
                      this.characters.map((character, i) => {                        
                        return (
                          <NavItem>
                            <NavLink className={ this.state.activeCharacter === character.id?`active`:``}     
                              className={this.state.activeCharacter === character.id?`btn btn-primary text-white active`:`btn btn-secondary text-white`}>
                              <span onClick={() => {this.toggleCharacter(character.id)}}>{character.id} </span>
                              <button class="close closeTab text-white ml-1" type="button" 
                              onClick={() => {
                                if (window.confirm("確認刪除?"))
                                {
                                  this.characters.splice(i, 1);
                                  this.forceUpdate();
                                }
                              }}
                              >×</button>                         
                              
                            </NavLink>                          
                          </NavItem>
                        )
                      })                    
                    }
                    <NavItem>
                      <NavLink onClick={() => {this.GS.addCharacter("新角色"+this.characters.length);this.forceUpdate()}}
                      className={`btn btn-primary text-white`}>
                        <FontAwesomeIcon icon={faUserPlus}/>
                        </NavLink>                          
                    </NavItem>
                    <NavItem className={(this.state.characterExpanded)?``:`ml-auto`}>
                      <NavLink onClick={() => {
                        this.setState(prevState => ({
                          characterExpanded: !prevState.characterExpanded      
                        }));
                      }}
                      className={`btn btn-primary text-white`}>
                        <FontAwesomeIcon icon={(this.state.characterExpanded)?faCaretLeft:faCaretRight}/>
                        {(this.state.characterExpanded)?" 隱藏":" 展開"}
                        </NavLink>                          
                    </NavItem>
                  </Nav>


                  <Modal isOpen={this.state.openModal}>
                    {
                      this.characters.map((character, i) => {return (
                      <div style={{display:(this.state.activeCharacter==character.id)?`show`:`none`}}>
                        <ModalHeader toggle={()=>{this.toggleModal(); this.state.activeCharacter='';}}>
                          {character.id}
                        </ModalHeader>
                        <ModalBody>
                          <CharacterSetting character={character}></CharacterSetting>
                        </ModalBody>
                        <ModalFooter>
                          <Button color="primary" onClick={()=>{this.GS.setCharacter(character.id);this.state.activeCharacter=character.id;this.forceUpdate();}}>套用到所有對白</Button>
                        </ModalFooter>
                      </div>
                      )})
                    }
                  </Modal>

                  
              </Col>

            </Row>       
          </Container>
    )
  }
}